import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// NOTE: Admin JWT is stored in localStorage. This is a deliberate trade-off for a
// single-admin marketing site — migrating to httpOnly cookies would require backend
// cookie/CSRF machinery and cross-origin credential support. The admin surface is
// small and not exposed to third-party scripts, so XSS risk is acceptable here.
const TOKEN_KEY = "regain_admin_token";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);
